import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminDashboard from '../pages/AdminDashboard';

const PrivateRoute = ({ children }) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" />;
  }

  if (children.type === AdminDashboard && !user.userMeta.roles.includes('admin')) {
    return <Navigate to="/" />;
  }

  return children;
};

// Не даёт уже залогиненному человеку зависнуть на форме входа — без этого
// checkAuth мог обнаружить живую SSO-сессию, а /login всё равно её показывал.
export const PublicOnlyRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return null;

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;
